import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PAGE_INDEX, PAGE_SIZE } from '~/utils/constants/common';
import { SortDirectionEnum } from '~/utils/enum';
import { IParamsPerson, IPerson } from '~/utils/interface/person';
import { handleGetPersonList } from './personThunk';

export interface PersonState {
  persons: Array<IPerson>;
  filter: IParamsPerson;
  totalItems: number;
  needRefreshData: boolean;
}

const initialState: PersonState = {
  persons: [],
  totalItems: 0,
  needRefreshData: false,
  filter: {
    username: '',
    search: '',
    searchBy: '',
    sortBy: '',
    provinceId: '',
    wardId: '',
    startDate: '',
    endDate: '',
    assignStatus: undefined,
    active: undefined,
    geofenceStatus: undefined,
    sortOrder: SortDirectionEnum.ASC,
    pageIndex: PAGE_INDEX,
    pageSize: PAGE_SIZE,
  },
};

const personSlice = createSlice({
  name: 'person',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IParamsPerson>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetFilter: (state) => {
      state.filter = initialState.filter;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetPersonList.pending, (_state, _action) => {})
      .addCase(handleGetPersonList.fulfilled, (state, action) => {
        const data = action.payload?.result?.data;
        state.persons = Array.isArray(data) ? data : [];
        state.totalItems = action.payload.result.total_record || 0;
        state.needRefreshData = false;
      })
      .addCase(handleGetPersonList.rejected, (_state, _action) => {});
  },
});

export const personActions = personSlice.actions;

const personReducer = personSlice.reducer;
export default personReducer;
